import { useContext } from 'react'

import categoryContext from 'contexts/categoryContext'

function useCategory () {
  return useContext(categoryContext)
}

export default useCategory
